/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Voucher } from './types';

const buscarVoucherPorCodigo = (codigo: string): AxiosPromise<Voucher> => xhr
    .get(`/vouchers/${codigo}`);

export default buscarVoucherPorCodigo;
